import React, {Component} from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import {withTranslation} from "react-i18next";

class EnhancedTableHead extends Component {
    createSortHandler = (property, sortable) => event => {
        if (sortable) {
            const {onRequestSort} = this.props;
            onRequestSort(event, property);
        }
    };
    render() {
        const {order, orderBy, columns, t} = this.props;

        return (
            <TableHead>
                <TableRow>
                    {columns.map(col => (
                        <TableCell
                            key={col.id}
                            align={col.numeric ? 'right' : 'left'}
                            padding={col.disablePadding ? 'none' : 'default'}
                            sortDirection={orderBy === col.id ? order : false}
                        >
                            <Tooltip title="Sort" placement={col.numeric ? 'bottom-end' : 'bottom-start'} enterDelay={300}>
                                <TableSortLabel
                                    active={orderBy === col.id}
                                    direction={order}
                                    onClick={this.createSortHandler(col.id, col.sortable)}
                                >
                                    {t(col.label)}
                                </TableSortLabel>
                            </Tooltip>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }
}

export default withTranslation('messages')(EnhancedTableHead);